import { requests } from './baseServices'


export const CurrencyServices = {   
    getAll: (criteria) => requests.get("api/currencies", criteria),
    getAllWithOptions: (criteria) => requests.post('api/currencies/filtered', criteria),
    getById: (id) => requests.get(`api/currencies/${id}`),
    update: (id, template) => requests.put(`api/currencies/${id}`, template),
    create: (template) => requests.post("api/currencies", template),
    duplicate: (id) => requests.post(`api/currencies/duplicate/${id}`),
    delete: (id) => requests.delete(`api/currencies/${id}`),
};